import React from 'react';
import ContactList from '../../components/crm/ContactList';

export const ContactsPage: React.FC = () => {
  return <ContactList />;
};